import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedin: false,
    keepLogin: false
  },
  mutations: {
    setIsLoggedin(state, isLoggedin) {
      state.isLoggedin = isLoggedin
    },
    setKeepLogin(state, keepLogin) {
      state.keepLogin = keepLogin
    }
  },
  actions: {
    setIsLoggedin(context, isLoggedin) {
      context.commit('setIsLoggedin', isLoggedin)
    },
    setKeepLogin(context, keepLogin) {
      context.commit('setKeepLogin', keepLogin)
    }
  },
  getters: {
    keepLogin: (state) => {
      return state.keepLogin
    },
  }
})
